import React, { useRef, useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import ReactSelect from "react-select";
import classnames from "classnames";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ListGroup,
  ListGroupItem,
  Label,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import BarLoader from "react-spinners/BarLoader";
import Select from "react-select";
import Templete from "../../Templete/Templete";

import AuthService from "../../../../services/User/AuthService";
import RechargeService from "../../../../services/User/RechargeService";
import LoadingContext from "../../../../store/loading-context";
import HttpError from "../../../../utill/HttpError";
import { useHistory } from "react-router-dom";

import OrderReviewDialog from "./OrderReviewDialog";
import ViewPlansDialog from "./ViewPlansDialog";

const RechargePlan = (props) => {
  const circle = props.circle;

  function handleCircleChange(e) {
    props.setCircle(e.target.value);
    fetchPlans(e.target.value);
  }

  const data = props.plansData;

  const circles = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar / Jharkhand", label: "Bihar / Jharkhand" },
    { value: "Chennai", label: "Chennai" },
    { value: "Delhi NCR", label: "Delhi NCR" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jammu Kashmir", label: "Jammu Kashmir" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Kolkata", label: "Kolkata" },
    {
      value: "Madhya Pradesh / Chhattisgarh",
      label: "Madhya Pradesh / Chhattisgarh",
    },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "North East", label: "North East" },
    { value: "Orissa", label: "Orissa" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "UP East", label: "UP East" },
    { value: "UP West", label: "UP West" },
    { value: "West Bengal", label: "West Bengal" },
  ];

  const loadingCtx = useContext(LoadingContext);
  const [loading, setIsLoading] = useState(false);
  const [tabsData, setTabsData] = useState([]); // Store dynamic tabs data
  const [topBorderTab, settopBorderTab] = useState("1");

  const fetchPlans = async (circle) => {
    const operator = props.operator ? props.operator.label : null;

    if (!operator || !circle) return;

    const found = props.prepaidOperator.find((e) => operator === e.label);
    if (!found) return;

    setIsLoading(true);

    try {
      const token = AuthService.getAccessToken();
      const responseData = await RechargeService.fetchPlans(
        token,
        operator,
        circle
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        // Save the response data with dynamic tabs
        setTabsData(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      props.handleOpen();
      Swal.fire("Opps!", errMsg, "error");
    }

    setIsLoading(false);
  };

  // Switch tab
  const topBordertoggle = (tab) => {
    if (topBorderTab !== tab) {
      settopBorderTab(tab);
    }
  };

  useEffect(() => {
    if (circle) {
      fetchPlans(circle);
    }
  }, [circle, props.operator]);

  return (
    <React.Fragment>
      <div
        className="card card-default"
        style={{ height: "525px", overflow: "auto", width: "100%" }}
      >
        <div className="card-header">
          <h3 className="card-title">Plans</h3>
          <div className="card-tools">
            <button
              className="btn btn-sm"
              style={{ backgroundColor: "transparent" }}
              onClick={() => fetchPlans(props.circle)}
            >
              <i className="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mx-auto">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <ReactSelect
                    options={props.prepaidOperator}
                    onChange={(e) => props.setOperator(e)}
                    value={props.operator}
                    formatOptionLabel={(operator) => (
                      <div>
                        <img
                          src={operator.image}
                          alt="logo-image"
                          height={30}
                        />
                        <span style={{ paddingLeft: "5px" }}>
                          {operator.label}
                        </span>
                      </div>
                    )}
                  />
                  <small className="mt-2">
                    Please note that plans are available for mobile operators
                    only.
                  </small>
                </div>

                <div
                  className="col-md-6"
                  onChange={(e) => handleCircleChange(e)}
                >
                  <select className="form-control">
                    <option value={props.circle}>
                      {props.circle ? props.circle : "Select Circle"}
                    </option>
                    {circles.map((e, key) => (
                      <option key={key} value={e.value}>
                        {e.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {loading && (
                <div className="pt-4">
                  <BarLoader color="#42ba96" loading={loading} width="100%" />
                </div>
              )}

              {tabsData.length > 0 && (
                <div className="pt-4">
                  <div
                    style={{
                      overflowX: "auto", // Horizontal scroll enabled
                      whiteSpace: "nowrap", // Prevent tabs from wrapping to the next line
                    }}
                  >
                    <Nav
                      tabs
                      className="nav nav-tabs nav-justified nav-border-top nav-border-top-success mb-3"
                    >
                      {tabsData.map((tab, index) => (
                        <NavItem key={index}>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: topBorderTab === String(index + 1),
                            })}
                            onClick={() => topBordertoggle(String(index + 1))}
                          >
                            {tab.tab_name}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  </div>

                  <TabContent activeTab={topBorderTab} className="text-muted">
                    {tabsData.map((tab, index) => (
                      <TabPane key={index} tabId={String(index + 1)}>
                        <table className="table table-hover table-responsive">
                          <tbody>
                            {tab.data.map((value, key) => (
                              <tr key={key}>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-info btn-circle btn-sm"
                                    onClick={() =>
                                      props.handleSetAmount(value.amount)
                                    }
                                  >
                                    ₹{value.amount}
                                  </button>
                                </td>
                                <td>
                                  <span className="text-muted font-weight-bolder d-block font-size-sm">
                                    {value.planDescription}
                                  </span>
                                  <span>Validity: {value.validity}</span>
                                </td>
                                <td className="pl-0 text-center">
                                  <a
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      props.handleSetAmount(value.amount)
                                    }
                                  >
                                    Choose
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </TabPane>
                    ))}
                  </TabContent>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RechargePlan;
